(function($) {
    'use strict';
    
    // Your custom JavaScript here
    
})(jQuery); 